module.exports = __webpack_public_path__ + "lb.0ed365a75623ab488e13.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/lb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/lb.svg
// module chunks = styles